/**
 * Copia texto para a área de transferência.
 *
 * `navigator.clipboard` exige contexto seguro (https ou localhost) e permissão.
 * Quando falha, cai para o método antigo com um textarea temporário — sem esse
 * fallback, o botão simplesmente não funcionaria em alguns contextos e o usuário
 * não saberia por quê.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // cai no fallback abaixo
  }

  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}
